/** Component `name` values matched by WorkspaceShell `<keep-alive include>`. */
export const SHELL_KEEP_ALIVE_NAMES = [
  'DashboardView',
  'PotentialView',
  'ModulePlaceholderView'
];

export const SHELL_KEEP_ALIVE_MAX = 6;

export function shellViewCacheKey(route) {
  const name = route?.name;
  return name ? String(name) : route?.path || '/';
}

export function lazyRouteView(importFn, cacheName) {
  return () =>
    importFn().then((mod) => {
      if (mod?.default && cacheName) {
        Object.defineProperty(mod.default, 'name', {
          value: cacheName,
          configurable: true
        });
      }
      return mod;
    });
}
